import { theDocument } from './env'

export function extractTitle() {
  return theDocument?.querySelector('title')?.innerHTML
}

export function extractCanonical() {
  return theDocument?.querySelector('link[rel="canonical"]')?.getAttribute('href') ?? undefined
}
